import React from 'react';
import { connect } from 'react-redux';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import WhatsappIcon from '@material-ui/icons/WhatsApp';
import { Inbox, Calendar, Edit3, BarChart2, ChevronsUp } from 'react-feather';
import {
  FONT_FAMILY_REGULAR,
  DARK_GRAY,
  LIGHT_GRAY,
  DARK_CYAN,
  FONT_FAMILY,
  GRAY,
} from '../../../../theme';
import FiltrosPreVisualizar from '../../../../shared/componentes/FiltrosPreVisualizar';
import CardTitle from '../../../../shared/componentes/CardTitle';
import preVisualizarImagem from '../../../../shared/img/pre_visualizar_imagem.png';
import VidroInclicavel from '../../../../shared/componentes/VidroInclicavel';
import ItemFiltrosPreVisualizar from '../../../../shared/componentes/ItemFiltrosPreVisualizar';
import { formatarDataParaString } from '../../../../shared/util/Utils';

const PreVisualizarScapeZero = (props) => {
  const {
    titulo,
    orientacoes,
    categoria,
    situacao,
    formaDeIngresso,
    perfilAluno,
    marca,
    campus,
    curso,
    modalidade,
    turno,
    dataInicioCampanha,
    dataTerminoCampanha,
    dataInicioMatricula,
    dataTerminoMatricula,
    criarCampanhaUpload,
    modeloDeRisco,
    impactoDaCampanha,
    grupoDeVisualizacao,
    marcaWhatsapp,
    primeiroContato,
    segundoContato,
    primeiraMensagem,
    segundaMensagem,
    terceiraMensagem,
  } = props;

  const useStyles = makeStyles({
    subtitulo: {
      fontSize: '14px',
      color: DARK_GRAY,
      fontFamily: FONT_FAMILY_REGULAR,
      padding: '8px 7px 0 7px',
    },
    container: {
      flex: '1',
      maxHeight: '100%',
    },
    containerTexto: {
      position: 'relative',
      overflowWrap: 'break-word',
      marginLeft: '16px',
      marginTop: '4px',
    },
    preVisualizar: {
      width: '100%',
      height: '100%',
      border: `1px solid ${LIGHT_GRAY}`,
      borderRadius: '6px',
      overflowY: 'auto',
      padding: '12px',
    },
    preVisualizarVazio: {
      width: '100%',
      height: '100%',
      border: `1px solid ${LIGHT_GRAY}`,
      borderRadius: '6px',
      padding: '2.3rem',
    },
    labelTitulo: {
      fontSize: '13px',
      color: DARK_CYAN,
    },
    imagemVazio: {
      height: '6rem',
      marginBottom: '1rem',
    },
    tituloVazio: {
      fontSize: '18px',
      color: GRAY,
      fontFamily: FONT_FAMILY,
      marginBottom: '0.6rem',
      fontWeight: '600',
    },
    subtituloVazio: {
      fontSize: '14px',
      color: GRAY,
      fontFamily: FONT_FAMILY_REGULAR,
    },
    tituloPrevia: {
      fontSize: '18px',
      color: GRAY,
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '800',
      textAlign: 'center',
      marginBottom: '32px',
      marginTop: '16px',
    },
    iconWhatsapp: {
      color: DARK_CYAN,
    },
  });

  const verificarSeCampoEstaPreenchido = () => {
    return (
      !titulo &&
      !orientacoes &&
      !categoria &&
      !situacao &&
      !perfilAluno &&
      formaDeIngresso.length === 0 &&
      !dataInicioMatricula &&
      !dataTerminoMatricula &&
      !modeloDeRisco &&
      grupoDeVisualizacao.length === 0 &&
      modalidade.length === 0 &&
      marca.length === 0 &&
      campus.length === 0 &&
      curso.length === 0 &&
      turno.length === 0 &&
      !dataInicioCampanha &&
      !dataTerminoCampanha &&
      !marcaWhatsapp &&
      !primeiraMensagem &&
      !segundaMensagem &&
      !terceiraMensagem
    );
  };

  const classes = useStyles();

  return (
    <>
      {verificarSeCampoEstaPreenchido() && (
        <Grid
          item
          container
          direction="column"
          wrap="nowrap"
          alignItems="center"
          justifyContent="center"
          className={classes.preVisualizarVazio}
        >
          <img
            alt="Pré-visualização"
            className={classes.imagemVazio}
            src={preVisualizarImagem}
          />
          <Typography noWrap align="center" className={classes.tituloVazio}>
            Pré-visualizar Campanha
          </Typography>
          <Typography align="center" className={classes.subtituloVazio}>
            Defina os filtros e conteúdo da mensagem para pré-visualizar a
            campanha
          </Typography>
        </Grid>
      )}
      {!verificarSeCampoEstaPreenchido() && (
        <Grid
          container
          alignItems="flex-start"
          justifyContent="flex-start"
          direction="row"
          className={`p-3 ${classes.preVisualizar}`}
        >
          <Grid>
            <Grid>
              <Typography className={classes.tituloPrevia} variant="h3">
                Prévia da Campanha
              </Typography>
            </Grid>
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <CardTitle text={titulo} icon={<Inbox />} />
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    className="mt-4"
                  >
                    <BarChart2 size={20} color={DARK_CYAN} />
                    <Typography
                      className={`${classes.labelTitulo} pl-1 pt-1`}
                      variant="h6"
                    >
                      Modelo de Risco
                    </Typography>
                  </Grid>
                  <Grid>
                    <ItemFiltrosPreVisualizar
                      descricao="Modelo de Risco"
                      valores={modeloDeRisco}
                      naoExpandir
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    className="mt-4"
                  >
                    <ChevronsUp size={20} color={DARK_CYAN} />
                    <Typography
                      className={`${classes.labelTitulo} pl-1 pt-1`}
                      variant="h6"
                    >
                      Impacto da Campanha
                    </Typography>
                  </Grid>
                  <Grid>
                    <ItemFiltrosPreVisualizar
                      valores={impactoDaCampanha}
                      naoExpandir
                    />
                  </Grid>
                </Grid>
              </Grid>
              <FiltrosPreVisualizar
                categoria={categoria ? [categoria] : []}
                situacao={situacao ? [situacao] : []}
                perfilAluno={perfilAluno ? [perfilAluno] : []}
                formaDeIngresso={
                  formaDeIngresso
                    ? formaDeIngresso.map((item) => {
                        return item.title;
                      })
                    : []
                }
                dataInicioMatricula={dataInicioMatricula}
                dataTerminoMatricula={dataTerminoMatricula}
                modalidade={
                  modalidade
                    ? modalidade.map((item) => {
                        return item.title;
                      })
                    : []
                }
                marca={
                  marca
                    ? marca.map((item) => {
                        return item.title;
                      })
                    : []
                }
                campus={
                  campus
                    ? campus.map((item) => {
                        return item.title;
                      })
                    : []
                }
                curso={
                  curso
                    ? curso.map((item) => {
                        return item.title;
                      })
                    : []
                }
                turno={
                  turno
                    ? turno.map((item) => {
                        return item.title;
                      })
                    : []
                }
                grupoDeVisualizacao={
                  grupoDeVisualizacao
                    ? grupoDeVisualizacao.map((item) => {
                        return item.title;
                      })
                    : []
                }
                criarCampanhaUpload={criarCampanhaUpload}
              />
            </Grid>

            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  className="mt-4"
                  alignItems="center"
                >
                  <Calendar size={20} color={DARK_CYAN} />
                  <Typography
                    className={`${classes.labelTitulo} pl-2 pt-1`}
                    variant="h6"
                  >
                    Data e Hora
                  </Typography>
                </Grid>
              </Grid>
              <ItemFiltrosPreVisualizar
                descricao="Data e Hora Início"
                valores={formatarDataParaString(dataInicioCampanha, true)}
                naoExpandir
              />
              <ItemFiltrosPreVisualizar
                descricao="Data e Hora Término"
                valores={formatarDataParaString(dataTerminoCampanha, true)}
                naoExpandir
              />
            </Grid>
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  className="mt-4"
                >
                  <WhatsappIcon size={20} className={classes.iconWhatsapp} />
                  <Typography
                    className={`${classes.labelTitulo} pl-1 pt-1`}
                    variant="h6"
                  >
                    Automação de Mensagens por WhatsApp
                  </Typography>
                </Grid>
                <ItemFiltrosPreVisualizar
                  descricao="Marca"
                  valores={marcaWhatsapp}
                />
                <ItemFiltrosPreVisualizar
                  descricao={`Após ${primeiroContato} contatos`}
                  valores={primeiraMensagem ? [primeiraMensagem] : []}
                />
                <ItemFiltrosPreVisualizar
                  descricao={`Após ${segundoContato} contatos`}
                  valores={segundaMensagem ? [segundaMensagem] : []}
                />
                <ItemFiltrosPreVisualizar
                  descricao="Ao término da Campanha"
                  valores={terceiraMensagem ? [terceiraMensagem] : []}
                />
              </Grid>
            </Grid>
            <Grid item container xs={12}>
              <Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  className="mt-4"
                  alignItems="center"
                >
                  <Edit3 size={20} color={DARK_CYAN} />
                  <Typography
                    className={`${classes.labelTitulo} pl-2 pt-1`}
                    variant="h6"
                  >
                    Orientações ao Atendimento
                  </Typography>
                </Grid>
                <Grid className={classes.containerTexto}>
                  <VidroInclicavel />
                  <Typography
                    style={{ WebkitUserModify: 'read-write-plaintext-only' }}
                    variant="body1"
                  >
                    {orientacoes}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    filtroCampanha: state.criarCampanha,
  };
};

export default connect(mapStateToProps)(PreVisualizarScapeZero);
